import { render, staticRenderFns } from "./EditarInscripcionDialog.vue?vue&type=template&id=53a8b452&"
import script from "./EditarInscripcionDialog.vue?vue&type=script&lang=js&"
export * from "./EditarInscripcionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports